//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isApp, system, getUserInfo} from '@/util/const'
import {setAuthorization} from '@/axios/userInfo'

export default {
    name: "register",
    data() {
        return {
            ISAPP: false,
            lang: '',
            img: '',
            noNike: true,
            isRule: false,
            isMask: false,
            isShow: 0,
            name: '',
            mobile: '',
            flag: false,
            resultCode: '',
            s: 3,
            timer: null,
            loading: false,
            docmHeight: '0',  //默认屏幕高度
            showHeight: '0',  //实时屏幕高度
            hidshow: true,  //显示或者隐藏footer,
            isResize: false, //默认屏幕高度是否已获取
        }
    },
    methods: {
        maskClick() {
            if (this.resultCode === 0) window.location.href = 'cmcchkh5action://close'
            this.isMask = false
            this.isShow = 0
            this.resultCode = ''
            this.s = 3
            clearInterval(this.timer)
            this.timer = null
        },
        ruleBox() {
            this.isMask = true
            this.isShow = 1
        },
        ruleBox1() {
            this.isMask = true
            this.isShow = 4
        },
        statusBox() {
            this.isMask = true
            this.isShow = 2
            this.timer = setInterval(() => {
                this.s--
                if (this.s < 0) {
                    this.s = 3
                    clearInterval(this.timer)
                    this.maskClick()
                }
            }, 1000)
        },
        confirmBox() {
            if (this.name === '' || this.mobile === '' || this.noNike === true) return;
            if (this.noNike === true) {
                this.$toast({msg: this.$t('register.rule2'), time: 2000})
                return;
            }
            let reg = /^[0-9]{8}$/
            if (!reg.test(this.mobile)) {
                this.$toast({msg: this.$t('register.rule1'), time: 2000})
                return
            }
            if (this.name === '') {
                this.$toast({msg: this.$t('register.nameTips'), time: 2000})
                return;
            }
            this.isMask = true
            this.isShow = 3
        },
        confirm() {
            if (this.flag === true) return
            this.loading = true
            this.flag = true
            this.$http.postOther('ticket_racing/5g/outlet/new', {
                phone: this.mobile,
                username: this.name
            }).then(res => {
                this.resultCode = res.data.body.result
                this.statusBox(res.data.body.result)
                this.flag = false
                this.loading = false
            })
        },
        keyDown(e) {
            let reg = /^\d {1,8}$/
            let oldMobile = this.mobile
            let newMobile = this.mobile.replace(reg, '')
            if (newMobile.length > 8) newMobile = newMobile.substr(0, 8)
            this.mobile = newMobile
        },
        scroll(){
            window.scrollTo(0, 0)
        },
    },
    watch: {
        showHeight() {
            if (this.docmHeight > this.showHeight) {
                this.hidshow = false
            } else {
                this.hidshow = true
            }
        }
    },
    mounted() {
        window.onresize = () => {
            console.log(document.documentElement.clientHeight, document.body.clientHeight)
            return (() => {
                if (!this.isResize) {
                    //默认屏幕高度
                    this.docmHeight = document.documentElement.clientHeight
                    this.isResize = true
                }
                //实时屏幕高度
                this.showHeight = document.body.clientHeight
            })()
        }
    },
    created() {
        this.ISAPP = isApp()
        // this.ISAPP = true
        if (!this.ISAPP) {
            let origin = window.location.origin
            let link = encodeURIComponent(`${origin}${window.location.pathname}#/register`)
            window.location.href = `${origin}/mylink/#/l?link=${link}`
        }
        window.getUserInfo = (obj) => {
            if (obj) {
                setAuthorization(obj.authorization)
            }
            if (!isApp() || system() === 'unknown') {

            } else {
                getUserInfo({callbackName: 'getUserInfo', needLogin: false})
            }
        }
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/register.vue